import React from 'react'
import { IoCall } from "react-icons/io5";
import { CiMail } from "react-icons/ci";
import { SlLocationPin } from "react-icons/sl";
import { t } from 'i18next';

export const Contact = () => {

  const whatsappNumber = '+9647704000004';
  const handleWhatsAppClick = () => {
    window.location.href = `https://wa.me/${whatsappNumber}`;
  };

  const emailAddress = 'siraj1@siraj-alnoor.co';
  const subject = '';
  const body = '';

  const handleEmailClick = () => {
    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const googleMapsLink = 'https://www.google.com/maps/';
  const handleGoogleMapsClick = () => {
    window.location.href = googleMapsLink;
  };

  return (
    <section id="Contact" className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-20">

        {/* Title */}
        <h2 className="text-5xl font-bold text-center text-[#1a0080] mb-16 tracking-wide">
          {t('contact.heading1')}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
  {/* Contact Info */}
          <div
            data-aos="fade-left"
            data-aos-duration="600"
            className="flex flex-col gap-7"
          >
            <h3 className="text-2xl font-semibold text-[#1a0080] mb-4">
              {t('contact.heading2')}
            </h3>

            {/* Cards */}
            <div
              onClick={handleWhatsAppClick}
              className="flex items-center gap-5 p-5 rounded-2xl bg-white shadow-md border border-gray-100 hover:shadow-xl hover:scale-[1.02] transition-all cursor-pointer"
            >
              <div className="bg-[#1a0080] p-4 rounded-xl shadow-md">
                <IoCall size={24} color="white" />
              </div>
              <p className="text-gray-800 text-lg font-speda font-medium tracking-wide">
                {t('contact.number')}
              </p>
            </div>

            <div
              onClick={handleEmailClick}
              className="flex items-center gap-5 p-5 rounded-2xl bg-white shadow-md border border-gray-100 hover:shadow-xl hover:scale-[1.02] transition-all cursor-pointer"
            >
              <div className="bg-[#1a0080] p-4 rounded-xl shadow-md">
                <CiMail size={24} color="white" />
              </div>
              <p className="text-gray-800 text-lg font-medium tracking-wide">
                {t('contact.email')}
              </p>
            </div>

            <div
              onClick={handleGoogleMapsClick}
              className="flex items-center gap-5 p-5 rounded-2xl bg-white shadow-md border border-gray-100 hover:shadow-xl hover:scale-[1.02] transition-all cursor-pointer"
            >
              <div className="bg-[#1a0080] p-4 rounded-xl shadow-md">
                <SlLocationPin size={24} color="white" />
              </div>
              <p className="text-gray-800 text-lg font-medium tracking-wide">
                {t('contact.location')}
              </p>
            </div>
          </div>
          {/* Google Maps */}
          <div
            data-aos="fade-right"
            data-aos-duration="600"
            className="w-full h-[380px] lg:h-[480px] rounded-3xl overflow-hidden shadow-2xl border border-gray-200"
          >
            <iframe
              title="google-maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d51929.903710432365!2d45.33645544358676!3d35.56311114189123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40002c0536d143b1%3A0xf791750d4e215dea!2sSulaymaniyah%2C%20Kurdistan%20Region!5e0!3m2!1sen!2siq!4v1753432633854!5m2!1sen!2siq"
              className="w-full h-full border-0"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

        
        </div>
      </div>
    </section>
  );
};